import { initReactI18next } from "react-i18next";

import { use, type i18n as i18nType } from "i18next";
import Backend from "i18next-http-backend";

const lang: string = localStorage.getItem("language") || "en";

const i18n = use(Backend)
	.use(initReactI18next)
	.init({
		fallbackLng: lang,
		lng: lang,
		interpolation: {
			escapeValue: false,
		},
		ns: [],
		defaultNS: ["translation"],
		react: {
			useSuspense: false,
		},
	}) as unknown as i18nType;

export default i18n;
